/**
 * Owner: Masa Bayu
 * File: typography-role.ts
 * Date:Time: 2026-09-13 21:04
 * Description: 22B typography roles and weight semantics.
 */
export const QX_TYPOGRAPHY_ROLES = [
    'display',
    'title',
    'heading',
    'subheading',
    'body',
    'body-emphasis',
    'caption',
    'label',
    'quote',
    'footnote',
];
export const QX_TYPOGRAPHY_WEIGHTS = ['regular', 'medium', 'semibold', 'bold'];
const FORBIDDEN = [
    'css',
    'fontSize',
    'lineHeight',
    'letterSpacing',
    'className',
    'style',
    'dom',
    'rem',
    'em',
    'px',
];
function assertNoForbidden(record, label) {
    for (const key of FORBIDDEN) {
        if (key in record) {
            throw new Error(`${label} must not include render field "${key}"`);
        }
    }
}
function assertRefId(value, label) {
    if (typeof value !== 'string' || value.trim().length === 0 || /\s/.test(value)) {
        throw new Error(`${label} must be a non-empty id without whitespace`);
    }
}
export function isQXTypographyRole(value) {
    return typeof value === 'string' && QX_TYPOGRAPHY_ROLES.includes(value);
}
export function isQXTypographyWeight(value) {
    return typeof value === 'string' && QX_TYPOGRAPHY_WEIGHTS.includes(value);
}
export function createQXTypographyRoleStyle(options) {
    assertNoForbidden({ ...options }, 'Typography role style');
    if (!isQXTypographyRole(options.role)) {
        throw new Error(`Invalid typography role: ${String(options.role)}`);
    }
    assertRefId(options.fontFamilyId, 'Typography role fontFamilyId');
    assertRefId(options.sizeStep, 'Typography role sizeStep');
    assertRefId(options.lineHeightStep, 'Typography role lineHeightStep');
    assertRefId(options.letterSpacingStep, 'Typography role letterSpacingStep');
    if (!isQXTypographyWeight(options.weight)) {
        throw new Error(`Invalid typography weight: ${String(options.weight)}`);
    }
    return Object.freeze({
        role: options.role,
        fontFamilyId: options.fontFamilyId.trim(),
        sizeStep: options.sizeStep.trim(),
        weight: options.weight,
        lineHeightStep: options.lineHeightStep.trim(),
        letterSpacingStep: options.letterSpacingStep.trim(),
    });
}
//# sourceMappingURL=typography-role.js.map